/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["fuse-navigation{display:flex;flex:1 0 auto}fuse-navigation #main-navigation{margin:0;padding:0;width:100%}"];
export { styles as styles };
